import { render } from "./DataUpload.vue?vue&type=template&id=5705303e"
import script from "./DataUpload.vue?vue&type=script&lang=js"
export * from "./DataUpload.vue?vue&type=script&lang=js"

import "./DataUpload.vue?vue&type=style&index=0&id=5705303e&lang=scss"

import exportComponent from "/builds/dock/research/autocbm/autocbm-ui/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__